import React, { useState } from 'react';
import { Form, Row, Col, Button, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';

import useFormValidation from 'hooks/useFormValidation';

import { meApi } from 'api';

const validationSchema = {
  username: {
    required: 'Username is required',
    type: 'username',
  },
  email: {
    required: 'Email is required',
    type: 'email',
  },
  phone: {
    type: 'phone',
  },
};

const MyPageEditForm = ({ me, onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const initialValues = {
    username: me?.username || '',
    email: me?.email || '',
    phone: me?.phone || '',
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    validateForm,
    isValid,
  } = useFormValidation(initialValues, validationSchema);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setError(null);

    try {
      const updatedData = {
        username: values.username,
        email: values.email,
        phone: values.phone,
      };

      await meApi.updateMe(updatedData);
      toast.success('Updated successfully');
      onSuccess();
    } catch (err) {
      setError(err.message);
      toast.error('Failed to update');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && <Alert variant="danger">{error}</Alert>}

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={values.username}
              onChange={e => handleChange('username', e.target.value)}
              onBlur={() => handleBlur('username')}
              isInvalid={touched.username && errors.username}
            />
            <Form.Control.Feedback type="invalid">
              {errors.username}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={values.email}
              onChange={e => handleChange('email', e.target.value)}
              onBlur={() => handleBlur('email')}
              isInvalid={touched.email && errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={values.phone}
              onChange={e => handleChange('phone', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="success" disabled={!isValid || loading}>
          {loading ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </Form>
  );
};

export default MyPageEditForm;
